import { useSelector } from "react-redux";

export const useDateFormat = () => {
  const dateFormat = useSelector((state) => state.commonReducer.commonProps.dateFormat);

  return dateFormat;
};
